import type { DestinationContext } from "../destinations";
import type { ShortcutIcon } from "../shortcuts";

/**
 * Pages du back-office proposées dans « Ajouter un raccourci > Une page »,
 * rangées par rubrique. Les pages par fiche (/edit/…) passent par la punaise,
 * l'export par son action (il attend le tableau d'origine en state).
 * Les conditions reprennent celles des menus et des gardes de route : une
 * page n'est proposée que si l'utilisateur peut vraiment l'ouvrir.
 */
export const BO_PAGE_SECTIONS = [
  { id: "data", labelKey: "bo.home.pageSection.data", label: "Données" },
  {
    id: "website",
    labelKey: "bo.home.pageSection.website",
    label: "Site internet",
  },
  {
    id: "advanced",
    labelKey: "bo.home.pageSection.advanced",
    label: "Site internet — CMS avancé",
  },
  { id: "eshop", labelKey: "bo.home.pageSection.eshop", label: "E-shop" },
  {
    id: "account",
    labelKey: "bo.home.pageSection.account",
    label: "Compte et réglages",
  },
] as const;

export type BoPageSection = (typeof BO_PAGE_SECTIONS)[number]["id"];

export type BoPage = {
  id: string;
  labelKey: string;
  label: string;
  path: string;
  icon: ShortcutIcon;
  section: BoPageSection;
  available?: (ctx: DestinationContext) => boolean;
};

export type Availability = BoPage["available"];

export const page = (
  id: string,
  label: string,
  path: string,
  icon: ShortcutIcon,
  section: BoPageSection,
  available?: Availability,
): BoPage => ({
  id,
  labelKey: `bo.home.page.${id}`,
  label,
  path,
  icon,
  section,
  available,
});

/** CMS simple : redirigé vers le CMS avancé quand celui-ci est seul. */
export const simpleCms: Availability = (ctx) => ctx.hasCms && !ctx.advancedCms;
export const advancedCms: Availability = (ctx) =>
  ctx.hasCms && ctx.advancedEnabled;
export const both =
  (a: Availability, b: Availability): Availability =>
  (ctx) =>
    (a?.(ctx) ?? true) && (b?.(ctx) ?? true);
export const withCr: Availability = (ctx) => !ctx.hideCr;
export const withEshop: Availability = (ctx) => ctx.haveEshop;
